// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__ciAHG","info":"Panel_info__XUKNh","btns":"Panel_btns__6IgjU","button":"Panel_button__-1s9N"};